const shopTheImage = {
    ShopTheImage: {
        baseStyle: {
            productsGrid: {
                gridTemplateColumns: {base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)'},
                gap: 'spacing.8',
                pb: 'spacing.8',
            },
        },
    },
}
export default shopTheImage
